import React from 'react';
export interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  isDisabled?: boolean;
  prefix?: JSX.Element | null;
  suffix?: JSX.Element | null;
  dataTestId?: string;
  onClick?: () => void;
}
export default function Button({
  type = 'button',
  isDisabled,
  children,
  className,
  prefix,
  suffix,
  dataTestId,
  onClick,
}: ButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={className}
      disabled={isDisabled}
      data-test-id={dataTestId}
    >
      {prefix && <div className="btn__prefix me-2">{prefix}</div>}
      {children}
      {suffix && <div className="btn__suffix ms-2">{suffix}</div>}
    </button>
  );
}
